import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit'

import axios from "axios";



const initialState = {
    entities: {},
    status: 'idle', // idle loading success fail  
    error: null
}
//GetReport/{AuthToken}/	
const PLATFORM = '../../WsWebServiceReporting/'

export const fetchDataReport = createAsyncThunk('reports/get', async (incomingVariable, thunkAPI) => {
    const bodies = {
        ReportCriteria:{...incomingVariable.ReportCriteria
        , HRANotCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotCompletedInRange === true ? "1" : "0"
        , HRACompletedInDateRange: incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.CompletedInRange === true ? "1" : "0"
        , HRANotStartedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotStartedInRange === true ? "1" : "0"
        , HRAStartedInDateRange: incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.StartedInRange === true ? "1" : "0"
        , HRANotModifiedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotModifiedInRange === true ? "1" : "0"
        , HRAModifiedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.ModifiedInRange === true ? "1" : "0"
        , HRANotFirstCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.NotFirstCompletedInRange === true ? "1" : "0"
        , HRAFirstCompletedInDateRange:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.FirstCompletedInRange === true ? "1" : "0"
        , HRAIsCompleteFlag:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.HRAIsCompleteFlag === true ? "1" : "0"
        , HRAIsNotCompleteFlag:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.HRAIsNotCompleteFlag === true ? "1" : "0"
        , IncludeAdditionalQuestions:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.IncludeAdditionalQuestions === true ? "1" : "0"
        , ExcludeInactiveParticipants:  incomingVariable && incomingVariable.ReportCriteria && incomingVariable.ReportCriteria.ExcludeInactiveParticipants === false ? "1" : "0"
        , ReportOutputFormat: "JSON"  
        , FirstRowHeader: "1"
        // , EligibleLives: "1"
        // , CompletionGoal: "1"
        // , AssessmentGuid: "1"
        // , ParticipantGuid: "1"
    }}
    try {
        const response = await axios.post(PLATFORM + "GetReport/" + incomingVariable.AuthToken + "/"
            , bodies
            , { headers: {'Content-Type': 'application/json'}}
            )
        const data = await response.data
        return data 
    } catch (err) {
        return thunkAPI.rejectWithValue({ error: err.message });
    }
})

const datareportSlice = createSlice({
    name: 'datareports',
    initialState,
    reducers: {
        datareportClear(state, action) {
            state.entities = initialState.entities
            state.status = 'idle'
            state.error = null
        },
        datareportModify(state, action) {
            const datareportData = action.payload
            state.entities[datareportData.Key] = datareportData.Value
        },

        datareportDelete(state, action) {
            const datareportData = action.payload
            delete state.entities[datareportData.Key]
        },
        datareportHydrate(state, action) {
            const datareportData = action.payload
            state.entities = datareportData
            state.status = 'success'
        },
        datareportResetStatus(state, action){
            state.status='idle'
        }
    },
    extraReducers(builder) {
        builder
            .addCase(fetchDataReport.pending, (state, action) => {
                state.status = 'loading'
            })
            .addCase(fetchDataReport.fulfilled, (state, action) => {
                const Success = action.payload.Success
                if (Success === true) {
                    state.error = null
                    state.status = 'success'
                    const loadedData = JSON.parse("["+action.payload.Info[0].DataReport+"]")

                    state.entities = loadedData
                } else {
                    state.status = 'failed'
                    state.error = action.payload.Status[0]
                }
            })
            .addCase(fetchDataReport.rejected, (state, action) => {
                state.error = action.error.message

            })
    }

})

export const { datareportClear, datareportModify, datareportDelete, datareportHydrate, datareportResetStatus } = datareportSlice.actions

export default datareportSlice.reducer

export const selectDataReportEntities = (state) => state.datareports.entities

export const selectDataReports = createSelector(selectDataReportEntities, (entities) =>
    Object.values(entities)
)

export const selectDataReportById = (state, DataReportId) => {
    return selectDataReportEntities(state)[DataReportId]
}

